<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/jala-investor-user";
import { serialize } from "object-to-formdata";

export default {
  extends: ModelCreate,
  page: {
    title: "Create JALA Trade Users",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_investor_users.singular')) }},
    resourceRoute: {default: 'jala_investor_users'},
    modelVariable: {default: 'jala_investor_user'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_investor_users.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_investor_users.plural')),
          href: "/jala_investor_users",
        },
        {
          text: this.$t("Create New"),
          href: "/jala_investor_users/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    getModelName(value) {
      return (value.user || {}).email || this.getModelKey(value)
    },
    store(value) {
      const { user: { avatar, ...user } } = value
      return this.$axios.post('jala/investor_users', {
        ...value,
        user: {
          ...user,
          send_email_verification: !user.email_verified
        },
        redirect: `${window.location.origin}/verify_email/success`
      }).then((response) => {
        const { data: { data } } = response;
        const files = {};
        if (avatar && typeof avatar !== 'string') files.avatar = avatar;
        if (this.lodash.isEmpty(files)) return response;
        return this.$axios.post(`jala/investor_users/${data.id}`, (
          serialize({ user: { id: data.user_id, ...files }, _method: 'PUT' })
        )).then(() => response).catch(() => response);
      })
    }
  }
}
</script>
